import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled, { css } from 'styled-components';
import { PrismicPreview } from '@prismicio/next';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { Header as BasicHeader } from '@store/components/Header';
import { media } from '@yoweb/ui/styles/utils';
import { Footer } from '@store/components/Footer';
import { HEADER_HEIGHT, HEADER_HEIGHT_DESKTOP } from '@store/constants/header';
import { getColor } from '@yoweb/ui/styles/utils/theme';
import { useStoreBraze } from '@store/hooks/useStoreBraze';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MaybePrismicPreview = function MaybePrismicPreview(_ref) {
  var children = _ref.children,
      repositoryName = _ref.repositoryName;

  // See: work around until the fix for WEB-5436 lands
  if (typeof globalThis === 'object') {
    return /*#__PURE__*/_jsx(PrismicPreview, {
      repositoryName: repositoryName,
      children: children
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
/**
 * Primary layout component most pages will be wrapped in.
 */


var MainLayout = function MainLayout(_ref2) {
  var _config$prismic;

  var children = _ref2.children,
      bgColor = _ref2.bgColor,
      _ref2$withTransparent = _ref2.withTransparentHeader,
      withTransparentHeader = _ref2$withTransparent === void 0 ? false : _ref2$withTransparent,
      _ref2$noFixedMinHeigh = _ref2.noFixedMinHeightForHeader,
      noFixedMinHeightForHeader = _ref2$noFixedMinHeigh === void 0 ? true : _ref2$noFixedMinHeigh,
      Header = _ref2.Header,
      _ref2$hideHeader = _ref2.hideHeader,
      hideHeader = _ref2$hideHeader === void 0 ? false : _ref2$hideHeader,
      _ref2$hideFooter = _ref2.hideFooter,
      hideFooter = _ref2$hideFooter === void 0 ? false : _ref2$hideFooter,
      _ref2$hideJoinButton = _ref2.hideJoinButton,
      hideJoinButton = _ref2$hideJoinButton === void 0 ? false : _ref2$hideJoinButton,
      _ref2$showSignInOnBan = _ref2.showSignInOnBanner,
      showSignInOnBanner = _ref2$showSignInOnBan === void 0 ? false : _ref2$showSignInOnBan,
      _ref2$hideGiftBanner = _ref2.hideGiftBanner,
      hideGiftBanner = _ref2$hideGiftBanner === void 0 ? false : _ref2$hideGiftBanner,
      _ref2$websiteRefreshE = _ref2.websiteRefreshEnabled,
      websiteRefreshEnabled = _ref2$websiteRefreshE === void 0 ? false : _ref2$websiteRefreshE;
  var config = useExternalConfig();
  useStoreBraze();
  return /*#__PURE__*/_jsx(MaybePrismicPreview, {
    repositoryName: config === null || config === void 0 ? void 0 : (_config$prismic = config.prismic) === null || _config$prismic === void 0 ? void 0 : _config$prismic.repository,
    children: /*#__PURE__*/_jsxs(MainLayoutContainer, {
      withTransparentHeader: withTransparentHeader,
      bgColor: bgColor,
      children: [!hideHeader ? Header !== null && Header !== void 0 ? Header : /*#__PURE__*/_jsx(BasicHeader, {
        showEmptySpace: !withTransparentHeader,
        hideJoinButton: hideJoinButton,
        showSignInOnBanner: showSignInOnBanner,
        hideGiftBanner: hideGiftBanner
      }) : null, /*#__PURE__*/_jsx(StyledMain, {
        withTransparentHeader: withTransparentHeader,
        noFixedMinHeightForHeader: noFixedMinHeightForHeader,
        children: children
      }), !hideFooter && /*#__PURE__*/_jsx(Footer, {
        websiteRefreshEnabled: websiteRefreshEnabled
      })]
    })
  });
};

var MainLayoutContainer = styled.div.withConfig({
  componentId: "sc-njgelb-0"
})(["display:flex;flex-direction:column;", ";", ""], function (_ref3) {
  var withTransparentHeader = _ref3.withTransparentHeader;
  return withTransparentHeader && css(["background-color:transparent;"]);
}, function (_ref4) {
  var bgColor = _ref4.bgColor;
  return bgColor && css(["background-color:", ";"], getColor(bgColor));
});
var StyledMain = styled.main.withConfig({
  componentId: "sc-njgelb-1"
})(["display:grid;", ""], function (_ref5) {
  var withTransparentHeader = _ref5.withTransparentHeader,
      noFixedMinHeightForHeader = _ref5.noFixedMinHeightForHeader;

  if (!noFixedMinHeightForHeader) {
    return css([""]);
  }

  if (withTransparentHeader) {
    return css(["min-height:100vh;"]);
  }

  return css(["min-height:calc(100vh - ", "px);", ""], HEADER_HEIGHT, media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        min-height: calc(100vh - ", "px);\n      "])), HEADER_HEIGHT_DESKTOP));
});
export default MainLayout;